import { SimpleSpinner as t } from "../SimpleSpinner/SimpleSpinner.js";
import { SimpleSearch as a } from "../SimpleSearch/SimpleSearch.js";
import { AdvanceSearch as c } from "../AdvanceSearch/AdvanceSearch.js";
import { TopBottomSearchFilterResults as o } from "../TopBottomSearchFilterResults/TopBottomSearchFilterResults.js";
import '../assets/SearchPanel.css';const i = "op_holder_Z2nsR", r = "op_holderAdvance_WgVtw", l = "op_switchButton_smNF8", n = {
  holder: i,
  holderAdvance: r,
  switchButton: l
};
function s(e) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: e.searchType == "advance" ? n.holder + " " + n.holderAdvance : n.holder }, e.searchType == "advance" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "This search allows you to create custom SQL-like searches."), /* @__PURE__ */ React.createElement(
    c,
    {
      change: e.onChange,
      runSearch: e.runSearch,
      fieldOptions: e.fieldOptions,
      operatorConditions: e.operatorConditions,
      inputConditions: e.inputConditions,
      searchSettings: e._condition_group,
      defaultCondition: e._condition_group._conditions[0]._condition
    }
  )) : /* @__PURE__ */ React.createElement(
    a,
    {
      searchTerm: e._condition_group._conditions[0]._condition._operator_and_value._value,
      onChange: e.onChange,
      path: "_condition_group._conditions.0._condition._operator_and_value._value"
    }
  ), /* @__PURE__ */ React.createElement(t, { on: e.spinner }), (e == null ? void 0 : e.searchOptions) !== null ? /* @__PURE__ */ React.createElement("button", { name: "searchType", value: e.searchType == "advance" ? "basic" : "advance", onClick: e.onChange, className: n.switchButton }, e.searchType == "advance" ? "Back to simple search" : "Advance Search") : ""), /* @__PURE__ */ React.createElement(
    o,
    {
      onChange: e.onChange,
      order_by: e.order_by,
      order: e.order,
      limit: e.limit,
      resultsCount: e.resultsCount,
      page: e.page,
      orderResultsByChoices: e.orderResultsByChoices,
      showLimit: e.showLimit
    },
    e.children
  ));
}
export {
  s as SearchPanel
};
